import React from 'react';
import { DroneEntity } from '@src/core/features';
import { FlightEntity } from '@src/features/order/entities';
import { getFlightPosition } from '@src/features/order/provider/flight-provider/flight-position-cache';

/**
 * Mission markers: coordinates only from telemetry cache (updated on every FLIGHT_DATA
 * in FlightProvider) or REST if no telemetry yet for that serial. Do not merge with
 * flightData/previousFlights here — that caused jitter; cache fixes teleport on return.
 */
export const useFlyingDrones = (
  missionDrones: DroneEntity[],
  flightData: FlightEntity | undefined | null
): DroneEntity[] => {
  return React.useMemo(() => {
    return missionDrones?.map((drone) => {
      const cached = getFlightPosition(drone.serialNumber);
      return {
        ...drone,
        latitude: cached?.latitude ?? drone.latitude,
        longitude: cached?.longitude ?? drone.longitude,
      };
    }) ?? [];
  }, [missionDrones, flightData]);
};
